// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import {
  performanceReportsPlantStatusSubRoute,
  PLANT_STATUS_SUB_PATH
} from '@features/performance-reports'
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import {STOPPAGE_ANALYSIS_SUB_PATH, stoppageAnalysisSubRoute} from '@features/stoppage-analysis'
import {FeatureTranslationsLoader} from '@hconnect/common/localization-loaders'
import {useFundamentalMuiTheme} from '@hconnect/uikit'
import {usePlantIdFromHierarchyId} from '@hproduce/suite-core'
import {CircularProgress, ThemeProvider} from '@mui/material'
import {Suspense} from 'react'
import {generatePath, RouteObject, useNavigate} from 'react-router'

import {processEngineerDashboardFeatureTranslations} from '../localization'
import {ProcessEngineerPlantDashboard} from '../pages'

const SuiteProcessEngineerDashboard = () => {
  const plantId = usePlantIdFromHierarchyId()
  const navigate = useNavigate()

  if (!plantId) {
    return null
  }

  const navigateToStoppageAnalysis = (equipmentId: string) => {
    void navigate(generatePath(STOPPAGE_ANALYSIS_SUB_PATH, {equipmentId}))
  }

  // TODO: add navigation for Suite
  // implement: renderRunningTimeTooltipFooter, shiftSummaryHref, myTasksHref
  return (
    <ProcessEngineerPlantDashboard
      plantId={plantId}
      onEquipmentClick={navigateToStoppageAnalysis}
      plantStatusPageHref={PLANT_STATUS_SUB_PATH}
    />
  )
}

const SuiteProcessEngineerDashboardRouteWrapper = () => {
  return (
    <FeatureTranslationsLoader translations={processEngineerDashboardFeatureTranslations}>
      <ThemeProvider theme={useFundamentalMuiTheme()}>
        <Suspense fallback={<CircularProgress color="secondary" size={80} />}>
          <SuiteProcessEngineerDashboard />
        </Suspense>
      </ThemeProvider>
    </FeatureTranslationsLoader>
  )
}

export const processEngineerDashboardRoute: RouteObject = {
  path: '*',
  children: [
    {
      index: true,
      element: <SuiteProcessEngineerDashboardRouteWrapper />
    },
    performanceReportsPlantStatusSubRoute,
    stoppageAnalysisSubRoute
  ]
}
